// extracted by mini-css-extract-plugin
export default {"feedbackPage":"feedbackPage___l_RHt","title":"title___EQmCB","description":"description___xpczk","additionalInfo":"additionalInfo___rY6t2"};